import { faDiagramProject } from '@fortawesome/pro-light-svg-icons';
import { faSquarePollVertical } from '@fortawesome/pro-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import CustomLink from '@pickleballinc/ui/components/ui/custom-link';
import clsx from 'clsx';

import { publicEnv } from '@/lib/env';

interface ResultsContainerProps {
  scoreId: string;
  bracketType: string;
  bracketsURL: string;
}

const ResultsContainer = ({ scoreId, bracketType, bracketsURL }: ResultsContainerProps) => {
  const medalWinnerRow = bracketType === 'B' || bracketType === 'GS' || bracketType === 'GS2';
  return (
    <div
      className={clsx(
        'flex h-[44px] w-full flex-row items-center justify-center px-3 sm:h-auto sm:w-[180px] sm:flex-col sm:items-start sm:gap-2 sm:border-l',
        medalWinnerRow ? 'border-white' : 'border-gray-200'
      )}
    >
      <CustomLink
        href={`https://${publicEnv.NEXT_PUBLIC_HOME_ROOT_URL}/results/match/${scoreId ? scoreId.toLowerCase() : ''}`}
        className='mr-4 flex items-center sm:mr-0'
      >
        <FontAwesomeIcon
          icon={faSquarePollVertical}
          className='mr-2 text-experiment w-4'
          size='sm'
        />
        <p className='text-sm text-experiment'>Results</p>
      </CustomLink>
      <CustomLink href={bracketsURL} className='mr-4 flex items-center sm:mr-0'>
        <FontAwesomeIcon icon={faDiagramProject} className='mr-2 text-experiment w-4' size='sm' />
        <p className='text-sm text-experiment'>View Bracket</p>
      </CustomLink>
    </div>
  );
};

export default ResultsContainer;
